import { render, staticRenderFns } from "./ProgramIcons.vue?vue&type=template&id=423b0943&scoped=true"
import script from "./ProgramIcons.vue?vue&type=script&lang=js"
export * from "./ProgramIcons.vue?vue&type=script&lang=js"
import style0 from "./ProgramIcons.vue?vue&type=style&index=0&id=423b0943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b0943",
  null
  
)

export default component.exports